import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'semantic-ui-react';

class Header extends React.Component {
  state = {
    isLoggedIn: false
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      isLoggedIn: nextProps.isLoggedIn
    });
  }

  render() {
    return (
      <header>
        <nav>
          <Menu>
            <div className='container-fluid'>
              <Menu.Menu position='left'>
                <Menu.Item>
                <Link className="flex" to={this.state.isLoggedIn ? '/dashboard' : '/'}>
                  <svg width="86" height="15" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15 0a2 2 0 012 2v1.992a1 1 0 01-.54.888L3.065 11.81a.1.1 0 00.045.19H17v3H2a2 2 0 01-2-2v-1.992a1 1 0 01.54-.888l13.395-6.93A.1.1 0 0013.89 3H0V0zm20 0v3H23l-2 2v1h14v3H21v1l2 2h12v3H22.828a2 2 0 01-1.414-.586l-2.828-2.828A2 2 0 0118 10.172V4.828a2 2 0 01.586-1.414L21.414.586A2 2 0 0122.828 0H35zm46.172 0a2 2 0 011.284.467l.13.119 2.828 2.828a2 2 0 01.578 1.239l.008.175v5.344a2 2 0 01-.467 1.284l-.119.13-2.828 2.828a2 2 0 01-1.239.578l-.175.008h-7.344a2 2 0 01-1.284-.467l-.13-.119-2.828-2.828a2 2 0 01-.578-1.239L69 10.172V4.828a2 2 0 01.467-1.284l.119-.13L72.414.586a2 2 0 011.239-.578L73.828 0h7.344zM41 0v12h11v3H40a2 2 0 01-2-2V0h3zm16 0v12h11v3H56a2 2 0 01-2-2V0h3zm24 3h-7l-2 2v5l2 2h7l2-2V5l-2-2z"
                      fill="currentColor" fillRule  ="evenodd" />
                  </svg>
                  <div className="vert-hr"></div>
                  <div> &nbsp; Developer Console </div>
                </Link>
                </Menu.Item>
              </Menu.Menu> 
              <Menu.Menu className="flex-center">
                {this.state.isLoggedIn && 
                  <ul id="nav-left-group" className="nav-group">
                    <li className="nav-link-container" name="keys" onClick={() => {this.props.onAction('keys')}}>
                      <a className="nav-link">&nbsp; Keys</a>
                    </li> 
                    <li className="nav-link-container" name="profile" onClick={() => {this.props.onAction('profile')}}>
                      <a className="nav-link">Profile</a>
                    </li> 
                    <li className="nav-link-container" name="logout" onClick={() => {this.props.onAction('logout')}}>
                      <a className="nav-link">Logout</a>
                    </li> 
                  </ul>
                }
                {!this.state.isLoggedIn && 
                  <a type="button" name="login" className="login btn btn-large btn-secondary" onClick={() => {this.props.onAction('login')}}>
                    <span>Login</span>
                  </a>
                }
              </Menu.Menu>
            </div>
          </Menu>
        </nav>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header.js